import React, { useState } from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";
import Icon from "../../../components/Icon";

// FAQ data pour les solutions d'émargement
// FAQ data pour les solutions d'émargement
const faqItems = [
  {
    id: 1,
    title: "Email",
    content: "Envoi automatique d'emails personnalisés aux apprenants avec codes d'accès uniques. Suivi en temps réel des ouvertures et confirmations de présence."
  },
  {
    id: 2,
    title: "Code / Lien",
    content: "Les étudiants peuvent accéder à la feuille de présence en ligne via un code ou un lien partagé. ",
    details: [
      "Rapide et sécurisé",
      "Compatible avec tous les appareils", 
    ]
  },
  {
    id: 3,
    title: "Direct",
    content: "En cas de besoin d'un emargement direct, vous pouvez utiliser le support de l'intervenant pour enregistrer les présences manuellement."
  },
];

const SolutionEmargement = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          {/* Côté gauche - Texte et FAQ */}
          <div className={styles.leftContent}>
            <h2 className={cn("h2", styles.title)}>
              Nos solutions d'émargements à distance
            </h2>
            <div className={styles.info}>
              Simplifiez la gestion de vos émargements avec nos solutions digitales adaptées à tous vos besoins de formation.
            </div>
            
            <div className={styles.faqList}>
              {faqItems.map((item) => (
                <ScrollParallax key={item.id} className={styles.faqItem}>
                  <div
                    className={cn(styles.faqHead, { [styles.active]: activeItem === item.id })}
                    onClick={() => toggleItem(item.id)}
                  >
                    <div className={styles.faqTitle}>
                      <span className={styles.questionNumber}>
                        {item.id.toString().padStart(2, '0')}.
                      </span>
                      {item.title}
                    </div>
                    <div className={styles.faqArrow}>
                      <Icon name="arrow-bottom" size="10" />
                    </div>
                  </div>
                  <div className={cn(styles.faqBody, { [styles.visible]: activeItem === item.id })}>
                    <div className={styles.faqContent}>
                      <p>{item.content}</p>
                      {item.details && (
                        <ul className={styles.detailsList}>
                          {item.details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.checkIcon}>
                                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>

          {/* Côté droit - Galerie d'images */}
          <div className={styles.rightContent}>
            <div className={styles.gallery}>
              {/* Image principale au centre */}
              <div className={styles.mainImage}>
                <div className={styles.imageBackground}>
                  <ScrollParallax animateIn="fadeInUp" offset={200}>
                    <img
                      src="/images/content/emargement-illustration.svg"
                      alt="Interface principale d'émargement"
                      className={styles.centralImage}
                    />
                  </ScrollParallax>
                </div>
              </div>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInRight" 
                offset={400}
                style={{
                  position: 'absolute',
                  top: '15%',
                  right: '2%',
                  zIndex: 3
                }}
              >
                <img
                  src="/images/content/emargement-code.svg"
                  alt="Émargement par code"
                  className={styles.floatingMedium}
                />
              </ScrollParallax>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInUp" 
                offset={500}
                style={{
                  position: 'absolute',
                  bottom: '-15%',
                  left: '8%',
                  zIndex: 4
                }}
              >
                <img
                  src="/images/content/emargement-qr.svg"
                  alt="Émargement direct"
                  className={styles.floatingLarge}
                />
              </ScrollParallax>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionEmargement;
